import { useLocation, useNavigate } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

// Global back button — shown in AppHeader on every non-root page.
// In RTL: the "<" pointing right (CaretRight) is the natural "back" affordance.
export default function BackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Hide on top-level routes to avoid a redundant control on the home tab.
  const HIDDEN = ["/", "/login", "/register"];
  if (HIDDEN.includes(pathname)) return null;

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      aria-label="رجوع"
      data-testid="global-back"
      className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-primary/40 bg-primary/5 text-primary hover:bg-primary/15 hover:border-primary/70 transition-all text-xs font-bold"
    >
      <CaretRight size={14} weight="bold" />
      <span className="hidden sm:inline">رجوع</span>
    </button>
  );
}
